import qs, { StringifiableRecord } from 'query-string'

export const addQueryParams = (url: string, params?: object) => {
    return qs.stringifyUrl({ url, query: params as StringifiableRecord })
}

export const removeQueryParams = (url: string, params: string[]) => {
    return qs.exclude(url, params)
}

// ensure an scheme exists at the start of the url and add one if it doesn't
export const ensureScheme = (url: string, scheme = 'https') => {
    return url.startsWith(`${scheme}://`) ? url : `${scheme}://${url}`
}

export const safeConcatenate = (urlA: string, urlB: string): string => {
    if (!urlB.startsWith('/')) urlB = '/' + urlB

    const base = new URL(urlA)
    const relative = new URL(urlB, 'http://x') // dummy base to parse relative URL

    base.pathname = base.pathname.replace(/\/+$/, '') + relative.pathname
    base.search = new URLSearchParams([
        ...base.searchParams,
        ...relative.searchParams,
    ]).toString()

    return base.toString()
}

export const parseQueryParams = (url: string) => {
    const parsedUrl = qs.parseUrl(url)
    return parsedUrl.query
}

export const documentUrl = (url: string, filename?: string | null) =>
    filename ? addQueryParams(url, { download: filename }) : url
